import { render } from "./consuleYG.vue?vue&type=template&id=8decbc0e&scoped=true"
import script from "./consuleYG.vue?vue&type=script&lang=js"
export * from "./consuleYG.vue?vue&type=script&lang=js"

import "./consuleYG.vue?vue&type=style&index=0&id=8decbc0e&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8decbc0e"]])

export default __exports__